// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"eed4e9bc","344":"09ac2168","507":"c340845c","830":"a2ab4b3c"}[chunkId] + ".chunk.js";
};